export const profileMessages = {
  cs: {
    "profile.trigger": "Uživatelský profil",
    "profile.account": "Uživatelský účet",
    "profile.myAccount": "Můj účet",
    "profile.settings": "Nastavení účtu",
    "profile.enterPortal": "Vstoupit do klientské části",
    "profile.appearance": "Vzhled",
    "profile.light": "Světlý",
    "profile.dark": "Tmavý",
    "profile.system": "Systém",
    "profile.language": "Jazyk",
    "profile.login": "Přihlásit se",
    "profile.logout": "Odhlásit se",
    "profile.loggingOut": "Odhlašování…",
    "profile.reloadAccount": "Znovu načíst účet",
    "profile.logoutFailed": "Odhlášení se nepodařilo. Zkuste to prosím znovu.",
    "profile.sharedIdentity": "Jméno a heslo patří vašemu společnému účtu Takeres a platí ve všech portálech.",
    "profile.close": "Zavřít",
    "profile.name": "Jméno",
    "profile.email": "E-mail",
    "profile.security": "Přihlášení a zabezpečení",
    "profile.securityDescription": "Heslo a propojená přihlášení spravujete ve společném účtu Takeres.",
    "profile.changePassword": "Změnit heslo",
    "profile.keepPassword": "Neměnit heslo",
    "profile.currentPassword": "Aktuální heslo",
    "profile.newPassword": "Nové heslo",
    "profile.confirmPassword": "Nové heslo znovu",
    "profile.cancel": "Zrušit",
    "profile.save": "Uložit změny",
    "profile.saving": "Ukládání…",
    "profile.passwordMismatch": "Nová hesla se neshodují nebo jsou příliš krátká.",
    "profile.incorrectPassword": "Aktuální heslo není správné.",
    "profile.invalidDetails": "Zkontrolujte vyplněné údaje a při změně hesla také aktuální heslo.",
    "profile.sessionExpired": "Vaše přihlášení vypršelo. Obnovte stránku a přihlaste se znovu.",
    "profile.saveFailed": "Účet se nepodařilo uložit. Zkuste to prosím znovu.",
  },
  en: {
    "profile.trigger": "User profile",
    "profile.account": "User account",
    "profile.myAccount": "My account",
    "profile.settings": "Account settings",
    "profile.enterPortal": "Enter the client area",
    "profile.appearance": "Appearance",
    "profile.light": "Light",
    "profile.dark": "Dark",
    "profile.system": "System",
    "profile.language": "Language",
    "profile.login": "Sign in",
    "profile.logout": "Sign out",
    "profile.loggingOut": "Signing out…",
    "profile.reloadAccount": "Reload account",
    "profile.logoutFailed": "We couldn’t sign you out. Please try again.",
    "profile.sharedIdentity": "Your name and password belong to your shared Takeres account and apply across all portals.",
    "profile.close": "Close",
    "profile.name": "Name",
    "profile.email": "Email",
    "profile.security": "Sign-in and security",
    "profile.securityDescription": "Manage your password and connected sign-in providers in your shared Takeres account.",
    "profile.changePassword": "Change password",
    "profile.keepPassword": "Keep current password",
    "profile.currentPassword": "Current password",
    "profile.newPassword": "New password",
    "profile.confirmPassword": "Confirm new password",
    "profile.cancel": "Cancel",
    "profile.save": "Save changes",
    "profile.saving": "Saving…",
    "profile.passwordMismatch": "The new passwords don’t match or are too short.",
    "profile.incorrectPassword": "The current password is incorrect.",
    "profile.invalidDetails": "Check the details you entered, including your current password when changing it.",
    "profile.sessionExpired": "Your session has expired. Refresh the page and sign in again.",
    "profile.saveFailed": "We couldn’t save your account. Please try again.",
  },
} as const;
